import { apm } from "@elastic/apm-rum";
import { PermMedia, PermMediaOutlined } from "@mui/icons-material";
import { Box, IconButton, Tooltip } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";

import { monitor } from "shared/common/services/apm-logging";
import { sidebarStore } from "shared/common/stores/sidebarStore";
import PopoverBox from "shared/common/utils/popover/PopoverBox";
import ImageFeatureInfo from "./imageInfoContent/ImageFeatureInfo";
import ImageInfoContent from "./imageInfoContent/ImageInfoContent";

export default function ImageInfo() {
  const { t } = useTranslation();

  const changeImagePopover = sidebarStore((state) => state.changeImagePopover);
  const imagePopover = sidebarStore((state) => state.imagePopover);
  const closeAllToolPopover = sidebarStore(
    (state) => state.closeAllToolPopover
  );

  //change table button and popover
  const handleClickImage = () => {
    closeAllToolPopover();
    changeImagePopover(!imagePopover);
  };

  return (
    <>
      <Tooltip
        title={t("tooltip.image")}
        placement="right"
        enterDelay={400}
        classes={{
          tooltip: "infra3d-buttonDescription",
        }}
      >
        <IconButton
          sx={{
            width: "40px",
            mx: "auto",
            color: "white",
            "@media (hover: hover)": {
              ":hover": { color: "secondary.main" },
            },
          }}
          classes={{
            root: imagePopover
              ? "infra3d-iconButtonRippleActive"
              : "infra3d-iconButtonRipple",
          }}
          className="onboarding-imageInformation"
          onClick={() =>
            monitor(apm, "change-status-imageInfo | Toolbar", handleClickImage)
          }
          disableRipple={true}
        >
          {!imagePopover && <PermMediaOutlined />}
          {imagePopover && <PermMedia />}
        </IconButton>
      </Tooltip>
      <PopoverBox visible={imagePopover}>
        {/* here the map code */}
        <Box
          display={"flex"}
          flexDirection={"column"}
          height={"100%"}
          sx={{
            transition: "gap 0.3s",
          }}
        >
          <ImageInfoContent />
          <ImageFeatureInfo />
        </Box>
      </PopoverBox>
    </>
  );
}
